import {Row, Col, Form} from 'react-bootstrap'
import {TFormSignature} from '../../signatureFormsTypes'
import {FormikErrors, FormikTouched} from 'formik'
import React from 'react'
import {RichTextEditor} from '../../../shared/RichTextEditor'
import {
  clientVarsByLead,
  clientVarsByPolicy,
  infoAgenteVars,
  infoPolicyVars,
} from '../../signatureFormsConst'

interface SignatureFormContentProps {
  values: TFormSignature
  errors: FormikErrors<TFormSignature>
  touched: FormikTouched<TFormSignature>
  handleChange: (field: string, value: string) => void
  handleBlur: (field: string) => void
}

export const SignatureFormContent: React.FC<SignatureFormContentProps> = ({
  values,
  errors,
  handleChange,
  handleBlur,
}) => {
  return (
    <div className='form-content'>
      <Row>
        <Col sm={12}>
          <div className='kt-heading kt-heading--md custom-border-brand'>
            Signature Form Content
          </div>
        </Col>
      </Row>

      <Row>
        <Col md={12} className='form-content-text'>
          <Form.Group>
            <Form.Label>
              Email Content{' '}
              {errors.formContent && <small className='text-danger'>{errors.formContent}</small>}
            </Form.Label>
            <RichTextEditor
              value={values.formContent}
              placeholder='Enter content Signature Form'
              onChange={(e) => handleChange('formContent', e)}
              btnCustomPicker={[
                clientVarsByLead,
                clientVarsByPolicy,
                infoPolicyVars,
                infoAgenteVars,
              ]}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  )
}
